import '@/app/panels.css';

import { Loader2 } from 'lucide-react';
import type { ReactElement } from 'react';
import { Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';

import { AppErrorBoundary } from '@/app/AppErrorBoundary';
import { PageTheme } from '@/app/PageTheme';
import { StoreProvider } from '@/app/StoreProvider';
import { CameraDragLayer } from '@/components/occurra/drag/CameraDragLayer';
import { Toaster } from '@/components/shadcn/sonner';
import { useContractViolationToasts } from '@/hooks/useContractViolationToasts';
import { useRuleNotificationToasts } from '@/hooks/useRuleNotificationToasts';
import { router } from '@/router';

export const App = (): ReactElement => {
    useRuleNotificationToasts();
    useContractViolationToasts();
    return (
        <AppErrorBoundary>
            {/* A toast raised while the organization or the sign-in changes must outlive the
                remount StoreProvider's key triggers, so both sit outside it. */}
            <Toaster />
            <CameraDragLayer />
            <StoreProvider router={router}>
                <PageTheme />
                <Suspense fallback={(
                    <div
                        role="status"
                        aria-label="Loading page"
                        className={`flex h-dvh items-center justify-center bg-occ-background-main
                            text-occ-foreground-tertiary`}
                    >
                        <Loader2 className="size-6 animate-spin" />
                    </div>
                )}
                >
                    <RouterProvider router={router} />
                </Suspense>
            </StoreProvider>
        </AppErrorBoundary>
    );
};
